


























import { Component, Ref, Mixins } from "vue-property-decorator";
import VModal from "@/components/VModal.vue";
import VIcon from "@/components/VIcon.vue";
import ScoutingGroupMixin from "@/mixins/http/ScoutingGroupMixin";
import { showErrorToast } from "@/utils/Toast";

@Component({
  components: {
    VModal,
    VIcon,
  },
})
export default class SlidesGenerationModal extends Mixins(ScoutingGroupMixin) {
  @Ref() readonly modal!: VModal;
  loading = false;
  link = "";

  async show(id: string) {
    this.loading = true;
    this.modal.show();
    try {
      const resp = await this.getGoogleSlideReport(id);
      this.link = resp.url;
    } catch (error) {
      this.link = "";
      this.modal.hide();
      showErrorToast(
        "Si è verificato un errore durante la generazione della presentazione"
      );
    }
    this.loading = false;
  }

  openSlides() {
    if (this.link) {
      window.open(this.link);
    }
  }
}
